import { useQuery } from '@tanstack/react-query';

import { withError } from '@/react-tools/react-query';
import axios, { parseAxiosError } from '@/portainer/services/axios';

import { ActiveAlertsResponse } from './types';

const queryKeys = {
  base: () => ['alerts', 'active'],
};

export function useActiveAlerts<T = ActiveAlertsResponse>({
  select,
  refetchInterval,
}: {
  select?: (data: ActiveAlertsResponse) => T;
  refetchInterval?: number;
}) {
  return useQuery(queryKeys.base(), async () => getActiveAlerts(), {
    ...withError('Unable to get alerts'),
    select,
    refetchInterval,
  });
}

export async function getActiveAlerts() {
  try {
    const { data } = await axios.get<ActiveAlertsResponse>(
      `/observability/alerting/alerts`,
      {
        params: { status: 'active' },
      }
    );
    return data;
  } catch (error) {
    throw parseAxiosError(error);
  }
}
